import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { ColorPicker, Divider, ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import TabLabel from '../TabLabel/TabLabel'
import { buttonSubTabs, subTabToColorGroup } from './constants'
import * as Styles from './styles'

const ButtonsAndLinks = ({ colors = {}, changeColor, disabled, activeSubTab, onSubTabChange, subTabErrors = {} }) => {
  const { t } = useTranslation()

  const subTabs = [
    {
      label: <TabLabel label={t('Primarios')} hasError={subTabErrors[buttonSubTabs.primaryButtons]} />,
      value: buttonSubTabs.primaryButtons,
    },
    {
      label: <TabLabel label={t('Simples')} hasError={subTabErrors[buttonSubTabs.simpleButtons]} />,
      value: buttonSubTabs.simpleButtons,
    },
    {
      label: <TabLabel label={t('Enlaces')} hasError={subTabErrors[buttonSubTabs.links]} />,
      value: buttonSubTabs.links,
    },
  ]

  const activeColorGroup = subTabToColorGroup[activeSubTab]
  const activeGroup = colors[activeColorGroup]
  const types = activeGroup ? Object.entries(activeGroup.types) : []

  return (
    <Styles.GroupContainer>
      <Styles.SubTabsSection>
        <ScrollableTabs tabs={subTabs} value={activeSubTab} onChange={onSubTabChange} />
      </Styles.SubTabsSection>
      {types.map(([typeKey, type], index) => (
        <Fragment key={typeKey}>
          <Styles.TypeSection>
            {index > 0 && (
              <Styles.SectionDivider>
                <Divider />
              </Styles.SectionDivider>
            )}
            <Styles.TypeContent>
              {type.label && <Text type="titleS">{t(type.label)}</Text>}
              <Styles.ColorsContainer>
                {Object.entries(type.colors).map(([colorKey, { label, color, orientation }]) => (
                  <ColorPicker
                    orientation={orientation}
                    onChange={value => changeColor({ value, group: activeColorGroup, type: typeKey, color: colorKey })}
                    label={t(label)}
                    defaultColor={color}
                    key={colorKey}
                    disabled={disabled}
                  />
                ))}
              </Styles.ColorsContainer>
            </Styles.TypeContent>
          </Styles.TypeSection>
        </Fragment>
      ))}
    </Styles.GroupContainer>
  )
}

export default ButtonsAndLinks
